import { Stack, type StackProps, Text } from '@chakra-ui/react';

import { IconLogo } from '../Logo/IconLogo';

export function LogoFooter(props: StackProps) {
  return (
    <Stack align="center" gap="16px" {...props}>
      <IconLogo color="fg.disabled" />
      <Text fontSize="xs" lineHeight="shorter" color="fg.subtle">
        Duke Education | RTO No. 22497
      </Text>
    </Stack>
  );
}
